import { Accordion, Typography } from "@mui/material";
import { styled } from "@mui/system";

export const StripedAccordion = styled(Accordion)(() => ({
  ":nth-of-type(even)": { backgroundColor: "#ffffff" },
  ":nth-of-type(odd)": { backgroundColor: "#f9f9f9" },
}));

export const TestingUtilitiesTitle = styled(Typography)(() => ({
  fontFamily: "Quicksand",
  fontSize: "16px",
  fontWeight: 600,
  marginTop: "20px",
}));
